import Modal from "./modal";

export default class UploadDocumentModal extends Modal {
  constructor(companyId, accept) {
    super("upload-modal");
    this.cb = null;
    this.companyId = companyId;
    this.$dropContainer = document.getElementById("drop-container");
    this.$uploadingMessage = document.getElementById("uploading-message");

    this.defineDocumentTypes(accept);

    this.uploader = new Uploader(
      this.$dropContainer,
      this.$uploadingMessage,
      (result) => {
        this.$modal.hide();

        if (typeof this.cb !== "undefined" && this.cb != null) {
          this.cb(result);
        } else if (
          typeof peque.documentsSection.folders.unassigned !== "undefined"
        ) {
          peque.documentsSection.getDocuments(
            peque.documentsSection.folders.unassigned
          );
        } else {
          location.reload();
        }
      }
    );
  }

  defineDocumentTypes(accept) {
    this.accept =
      accept ||
      "application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation";
    this.$fileInput = this.$dropContainer.querySelector("input[type=file]");
    this.$fileInput.setAttribute("accept", this.accept);

    this.documentIcons = this.accept.split(",").reduce(
      (icons, type) => {
        if (type.indexOf("pdf") >= 0) {
          return { ...icons, pdf: true };
        }
        if (type.indexOf("excel") >= 0 || type.indexOf("sheet") >= 0) {
          return { ...icons, excel: true };
        }
        if (type.indexOf("word") >= 0) {
          return { ...icons, word: true };
        }
        if (
          type.indexOf("powerpoint") >= 0 ||
          type.indexOf("presentation") >= 0
        ) {
          return { ...icons, powerPoint: true };
        }
      },
      { pdf: false, excel: false, word: false, powerPoint: false }
    );

    Object.entries(this.documentIcons).forEach(([type, enabled]) => {
      if (!enabled) {
        const iconElement = this.$dropContainer.querySelector(
          `[data-icon="${type}"]`
        );
        iconElement.style.display = "none";
      }
    });
  }

  setCallback(cb) {
    this.cb = cb;
  }
}
